import * as React from 'react';
// @ts-nocheck
import HighchartsReact from 'highcharts-react-official';
// @ts-nocheck
import Highcharts from 'highcharts';
// @ts-ignore
import HC_more from 'highcharts/highcharts-more';
import { DLSListItem, TicketListItem } from '../../../pages/company_operations/time_administration/types';
import makeDraggable from '../../../utilities/draggableDiv';
import './TicketGap.css';
import Tooltip from 'src/components/common/Dynamic-old/Tooltip';
HC_more(Highcharts);

interface IProps {
    dlsList: Array<DLSListItem> | null;
    mapDls: Number | null | undefined;
    setMapDls: (DLSListItem: Number) => void;
}

const TicketGap: React.FC<IProps> = (props: IProps) => {
    //r-18-lint-dj
    //eslint-disable-next-line
    const { dlsList, mapDls, setMapDls } = props;
    const [activeDls, setActiveDls] = React.useState(dlsList ? dlsList[0]?.dlsid : 0);
    const [categories, setCategories] = React.useState([] as Array<string>);
    const [graphData, setGraphData] = React.useState([] as Array<any>);
    const [ticketModalState, setTicketModalState] = React.useState<boolean>(false)

    // FIXME: cgm currently not allowing the dropdown to change the ticket gap table like it should
    // const handleDlsChange = (e: any) => {
    //     //console.log(e.target.value, e)
    //     setMapDls(Number(e.target.value));
    //     setActiveDls(mapDls => mapDls);
    // }

    React.useEffect(() => {
        //console.log("Initial Data: ", props.dlsList);
        let newCategories: Array<string> = [];
        let gapData: Array<any> = [];
        let workedData: Array<any> = [];
        let data: DLSListItem | null = dlsList?.find((dls: DLSListItem) => dls.dlsid === activeDls) || null;
        if (data !== null && data) {
            //r-18-lint-dj
            //eslint-disable-next-line
            data?.ticketList.map((ticket: TicketListItem) => {
                newCategories.push(`<div style="height: 32px;">
                    ${ticket.ticketNumber}<br />${ticket.status}
                </div>`);
                gapData.push({
                    y: ticket.gapMinutes, dataLabels: {
                        enabled: true,
                        align: "right",
                        color: "#FFF",
                        x: -20,
                    }
                });
                workedData.push({
                    y: ticket.durationMinutes, dataLabels: {
                        enabled: true,
                        align: "right",
                        color: "#FFF",
                        x: -20,
                        useHTML: true,
                        formatter: function (this: any): any {
                            return `
                        <div class="d-flex flex-row justify-content-between align-items-center">
                            <span style="margin-right: 20px;" class="font-weight-bold">${this.y}</span>
                            <span>${ticket.startTime} - ${ticket.endTime}</span>
                        </div>
                        `
                        }
                    }
                });
            });
            setGraphData([
                { name: "Gap", data: gapData, color: "#FF6A00", className: "tg-graph-data", dataGrouping: { groupPixelWidth: 40 } },
                { name: "Worked", data: workedData, color: "#0026FF", className: "tg-graph-data", dataGrouping: { groupPixelWidth: 40 } },
            ]);
            setCategories(newCategories);
        } else {
            setGraphData([]);
            setCategories([]);
        }
        //cgm sets Ticket Gap Table list
        setActiveDls(Number(mapDls));
        //r-18-lint-cm
        //eslint-disable-next-line
    }, [activeDls, mapDls])

    //cgm setting height for the ticket time gap section to standardize bar size and spacing
    let timeGapHeight: number = 80;
    categories.length > 5 ?
        timeGapHeight *= categories.length :
        timeGapHeight = 115 * categories.length

    const handleTicketClick = () => {
        setTicketModalState(!ticketModalState);
    }

    const closeTicketModal = () => {
        setTicketModalState(!ticketModalState);
    }

    const showTicketModal = () => {
        return (
            <div id='ticket-gap-container'>
                <div id='ticket-gap-content' style={{ top: 50, left: 50 }} >
                    <div id='draggable-section' className="w-100 d-flex justify-content-end align-items-center">
                        <button className="action-text-danger material-icons"
                            // style={{position: 'absolute', top: 5, right: 5, padding: 0, zIndex: 25 }} 
                            onClick={closeTicketModal}
                        >
                            close
                        </button>
                    </div>
                    <div id="inner-ticket-gap-content">
                        {showTicketGapTable()}
                    </div>


                </div>
            </div>
        )
    }

    const modalDraggable = () => {
        document.getElementById("ticket-gap-content") &&
            makeDraggable(document.getElementById("ticket-gap-content"))
    }

    React.useEffect(() => {
        modalDraggable();
    }, [ticketModalState])

    const showTicketGapTable = () => {
        return (
            <HighchartsReact
                highcharts={Highcharts}
                // containerProps={{ style: { width: "100%" } }}
                options={
                    {
                        chart: {
                            type: 'bar',
                            height: timeGapHeight,
                            width: 600
                        },

                        title: {
                            text: 'Ticket Time Gaps'
                        },

                        // x and y axis are swapped x is vertical
                        xAxis: {
                            categories: categories,
                            title: {
                                text: "Tickets"
                            },

                            labels: {
                                useHTML: true
                            },
                            height: "100%",

                        },
                        // y is horizontal axis
                        yAxis: {
                            // min: 0,
                            // max: 60,
                            title: {
                                text: "Minutes"
                            },
                        },
                        tooltip: {
                            valueSuffix: ' minutes',
                            outside: true,
                        },
                        plotOptions: {
                            bar: {
                                dataLabels: { enabled: false },
                                pointWidth: 22,
                                dataGrouping: {
                                    groupPixelWidth: 20
                                },
                                groupPadding: .1
                            }
                        },
                        legend: {
                            // layout: 'vertical',
                            // align: 'right',
                            // verticalAlign: 'top',
                            // x: -40,
                            // y: 80,
                            // floating: true,
                            // borderWidth: 1,
                            // backgroundColor: '#FFFFFF',
                            // shadow: true
                        },
                        credits: {
                            enabled: false
                        },
                        //@ts-ignore
                        series: graphData
                    }
                }
            />)
    }

    return <div className="w-100" style={{ maxHeight: 350, overflow: "scroll" }}>
        <div className='col-6'>
            {/* <select value={activeDls} onChange={handleDlsChange} className="position-absolute top-0 right-0 z-1" style={{top: 0, left: 15}}>
            {dlsList
            ?
            dlsList.map((dls: DLSListItem) => (
                <option value={dls.dlsid}>{dls.dlsid} ({dls.ticketCount} Tickets)</option>
                
            ))
            :
            <span>No Options...</span>
            }
        </select> */}
        </div>

        <span className='' style={{ top: 0, right: 0 }}>
            <div className='d-flex flex-row-reverse'>
                <i onClick={handleTicketClick} className="d-flex material-icons action-text ">fit_screen</i>
                <Tooltip name="TT-Time-Gap" />
            </div>

        </span>
        {ticketModalState && showTicketModal()}
        {showTicketGapTable()}
    </div>
}

export default TicketGap;